window.acceleratedDataQueue = window.acceleratedDataQueue || [];
window.acceleratedDataQueue.push({
    'ACC_TDT_Menu_02': {
        init() {
            this.runAt('ul.mobile-nav li a[href*="/collections/dark-tenor"]', ([target]) => {
                target.closest('ul.mobile-nav').classList.add(`${this.__testName}-modified`);
                const mobNavShop = document.querySelector('ul.mobile-nav a#Label-pages-shop1');
                if (mobNavShop) mobNavShop.textContent = 'Merchandising';
                const deskNavShop = document.querySelector('#SiteHeader .header-layout .header-item summary.site-nav__link[aria-controls="site-nav-item--1"]');
                if (deskNavShop) deskNavShop.childNodes[0].textContent = 'Merchandising'
            })
        }
    }
});